import { render, staticRenderFns } from "./SettingsIntercomCallback.vue?vue&type=template&id=096aa252&scoped=true&lang=pug&"
import script from "./SettingsIntercomCallback.vue?vue&type=script&lang=js&"
export * from "./SettingsIntercomCallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096aa252",
  null
  
)

export default component.exports